<script setup lang="ts">
import { computed } from 'vue'
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from '@/foundation/form'
import { Input } from '@/foundation/input'
import TicketDescription from '@/views/tickets/components/TicketDescription.vue'
import AutoFormLabel from './AutoFormLabel.vue'
import type { FieldProps } from './interface'
import { beautifyObjectName } from './utils'

const props = defineProps<FieldProps>()
const inputComponent = computed(() => (props.config?.component === 'ticketDescription' ? TicketDescription : Input))
// const inputComponent = computed(() => (props.config?.component === 'textarea' ? Textarea : Input))

const getComponentProps = (componentField: any) => {
  if (props.config?.component === 'ticketDescription') {
    // For TicketDescription component, we need to handle v-model differently
    return {
      modelValue: componentField.value,
      'onUpdate:modelValue': componentField['onUpdate:modelValue'],
      ticketId: props.config?.inputProps?.ticketId,
      ...props.config?.inputProps,
    }
  } else {
    return { ...componentField, ...props.config?.inputProps }
  }
}
</script>

<template>
  <FormField v-slot="slotProps" :name="fieldName">
    <FormItem v-bind="$attrs">
      <AutoFormLabel v-if="!config?.hideLabel" :required="required">
        {{ config?.label || beautifyObjectName(label ?? fieldName) }}
      </AutoFormLabel>
      <FormControl>
        <slot v-bind="slotProps">
          <component
            :is="inputComponent"
            type="text"
            v-bind="getComponentProps(slotProps.componentField)"
            :disabled="disabled"
          />
        </slot>
      </FormControl>
      <FormDescription v-if="config?.description">
        {{ config.description }}
      </FormDescription>
      <div class="flex gap-2">
        <FormDescription
          v-if="slotProps.componentField.modelValue && config?.showCharacterCount"
          :class="{ 'text-red-500 font-semibold': slotProps.componentField.modelValue.length > config?.maxLength }"
        >
          {{ slotProps.componentField.modelValue.length }}/{{ config?.maxLength }}
        </FormDescription>
        <FormMessage />
      </div>
    </FormItem>
  </FormField>
</template>
